import { FormControlLabel } from '@material-ui/core';
import { FlatButton } from 'material-ui';
import * as React from 'react';
import { ProjectLinkModel, ServiceModel, UspModel } from '../../../../models'
import { Views } from '../../../abstract';
import { ProjectViews } from '../../abstract';
import GalleryCard from './ProjectAddEditViewGalleryImageCard';

interface IDashboardProjectAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
    projectTypesSearchResult: ProjectLinkModel.Model[]
    uspSearchResult: UspModel[]
    servicesSearchResult: ServiceModel[]
    onCreateContent: (type: string) => void
    onSearchContent: (s: string, t: string) => void
    // onAddImageToGallery: (file: any) => void
}

class DashboardProjectAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardProjectAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public onSelect(sItems: any, fName: string) {
        this.clearErrorLabel();
        const { model } = this.state;
        model[fName] = sItems
        this.setState({ model });
    }

    public onSelectTextChange(s: string, name: any) {
        s = s.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '');
        const { onSearchContent } = this.props;
        return onSearchContent(s, name);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['title'].ru && model['title'].en) {
            if(model['keywords'].ru && model['keywords'].en){
                if (model['subtitle'].ru && model['subtitle'].en) {
                    if (model['previewImage'].ru) {
                        if (model['previewImage']['alt'].ru && model['previewImage']['alt'].en) {
                            if (model['image'].ru) {
                                if (model['image']['alt'].ru && model['image']['alt'].en) {
                                    if (model['description'].ru && model['description'].en) {
                                        if (model['services'].length) {
                                            // if (model['usp']) {
                                                // if (model['types'].length) {
                                                    // model['usp'] = model['usp'].value
                                                    model['types'] = model['types'].map((b: any) => b.value)
                                                    model['position'] = model['position'] ? Number(model['position']) : undefined;
                                                    onSave();
                                                // } else {
                                                //     this.setState({ error: 'Добавьте ссылки на типы оказанных услуг' } as any)
                                                // }
                                            // } else {
                                            //     this.setState({ error: 'Добавьте УТП!' } as any)
                                            // }
                                        } else {
                                            this.setState({ error: 'Выберите услугу(-и)!' } as any)
                                        }
                                    } else {
                                        this.setState({ error: 'Загрузите описание проекта на обоих языка!' } as any)
                                    }
                                } else {
                                    this.setState({ error: 'Заполните описание основного изображения на обоих языках!' } as any)
                                }
                            } else {
                                this.setState({ error: 'Загрузите основное изображение для русского языка!' } as any)
                            }
                        } else {
                            this.setState({ error: 'Заполните описание изображения предпросмотра на обоих языках!' } as any)
                        }
                    } else {
                        this.setState({ error: 'Загрузите изображение предпросмотра для русского языка!' } as any)
                    }
                } else {
                    this.setState({ error: 'Заполните подзаголовок на всех языках!' } as any)
                }
            } else {
                this.setState({ error: 'Заполните мета ключевые слова на всех языкых!' } as any)
            }
        } else {
            this.setState({ error: 'Заполните заголовок на всез языках!' } as any)
        }
    }

    public renderLeftSide() {
        const { model, languageTabValue } = this.state;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Заголовок"
                    fullWidth={true}
                    name="title"
                    value={model['title'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Подзаголовок (не более 250 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="250"
                    name="subtitle"
                    value={model['subtitle'] && model['subtitle'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Описание"
                    fullWidth={true}
                    multiLine={true}
                    name="description"
                    value={model['description'] && model['description'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Мета ключевые слова"
                    fullWidth={true}
                    multiLine={true}
                    name="keywords"
                    value={model['keywords'] && model['keywords'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['previewImage'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files, 'previewImage')}
                    multiple={false}
                    onClear={() => this.onDropImage(null,'previewImage')}
                    placeholder="предпросмотра"
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="previewImage alt"
                    value={model['previewImage']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['image'][languageTabValue]}
                    onDrop={(files: any) => this.onDropImage(files, 'image')}
                    multiple={false}
                    placeholder="основное"
                    onClear={() => this.onDropImage()}
                    accept="image/*"
                />
                <Views.TextField
                    floatingLabelText="Мета-описание изображения"
                    fullWidth={true}
                    name="image alt"
                    value={model['image']['alt'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Позиция в списке"
                    fullWidth={true}
                    data-type="number"
                    data-field-type="nml"
                    name="position"
                    value={model['position'] ? model['position'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.Dropzone
                    file={model['metaImages']?model['metaImages']['fb']:null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages fb')}
                    multiple={false}
                    onClear={() => this.onDropImage(null,'metaImages fb')}
                    placeholder="для meta Facebook и Twitter"
                    accept="image/*"
                />
                <Views.Dropzone
                    file={model['metaImages']?model['metaImages']['vk']:null}
                    onDrop={(files: any) => this.onDropImage(files, 'metaImages vk')}
                    multiple={false}
                    onClear={() => this.onDropImage(null,'metaImages vk')}
                    placeholder="для meta Vk"
                    accept="image/*"
                />
            </React.Fragment>
        )
    }

    public onDeleteGalleryImageFromStack(index: number) {
        const { model } = this.state;
        if (model['gallery'][index].id) {
            model['galleryImagesToDelete'].push(model['gallery'][index])
        }
        model['gallery'] = model['gallery'].filter((img: any, i: number) => i !== index);
        this.setState({ model });
    }

    public renderRightSide() {
        const { model, languageTabValue } = this.state;
        const { onCreateContent, uspSearchResult, projectTypesSearchResult, servicesSearchResult } = this.props;
        return (
            <React.Fragment>
                <FormControlLabel
                    style={{ alignSelf: 'flex-start' }}
                    control={
                        <Views.Switch
                            checked={model['published']}
                            onChange={(e, c) => { model['published'] = c; this.setState({ model }) }}
                            color="black"
                        />
                    }
                    label="Опубликовано"
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Услуги"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Services')}
                    onChange={(o: any) => this.onSelect(o, 'services')}
                    options={servicesSearchResult.map(e => ({ label: e.title[languageTabValue as any], value: e }))}
                    value={model['services']}
                />
                <Views.Select
                    name="select"
                    multi={false}
                    placeholder="УТП"
                    onInputChange={(s) => this.onSelectTextChange(s, 'Usp')}
                    onChange={(o: any) => this.onSelect(o, 'usp')}
                    options={uspSearchResult.map(e => ({ label: e.name, value: e }))}
                    value={model['usp']}
                />
                <FlatButton
                    label="Добавить новое УТП"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('usps')}
                />
                <Views.Select
                    name="select"
                    multi={true}
                    placeholder="Ссылки"
                    onInputChange={(s) => this.onSelectTextChange(s, 'ProjectLinks')}
                    onChange={(o: any) => this.onSelect(o, 'types')}
                    options={projectTypesSearchResult.map((e: any) => ({ label: e.name, value: e }))}
                    value={model['types']}
                />
                <FlatButton
                    label="Добавить новую ссылку"
                    style={{ marginTop: 10 }}
                    onClick={() => onCreateContent('project-links')}
                />
                <div style={{ display: 'inline-flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', width: '100%', border: '1px solid lightgray', padding: '0 20px', marginTop: 35 }}>
                    <h4 style={{ width: '100%', textAlign: 'center' }}>Галерея проекта:</h4>
                    <Views.Dropzone
                        onDrop={(files: any) => this.onDropImage(files, 'gallery', true)}
                        placeholder="проекта (можно несколько)"
                        multiple={true}
                        style={{ marginTop: 0, marginBottom: 30 }}
                        onClear={() => this.onDropImage()}
                        accept="image/*"
                    />

                    {model['gallery'] ? model['gallery'].map((image: any, index: number) => {
                        return (
                            <GalleryCard
                                index={index}
                                key={index}
                                image={image}
                                onDeleteGalleryImageFromStack={() => this.onDeleteGalleryImageFromStack(index)}
                                onTextChange={(e) => this.onTextChange(e, '', index)}
                                languageTabValue={languageTabValue}
                            />)
                    }) : null}
                </div>
            </React.Fragment>
        )
    }
}

export default DashboardProjectAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/project/addedit/ProjectAddEditView.tsx